import { on, select, selectAll, addClass, removeClass, hasClass } from 'modules/dom'
import { map } from 'modules/utils'
import debounce from 'lodash.debounce';

const body = document.body
const ACTIVATE_CLASS = 'sidebar-visible'

export default function (el) {
  const sidebarToggleButton = select('.js-sidebar-toggle', body)
  const closeButton = select('.js-close-sidebar', el)
  const activateSidebarDetail = () => addClass(ACTIVATE_CLASS, body)
  const deactivateSidebarDetail = () => removeClass(ACTIVATE_CLASS, body)

  if (sidebarToggleButton) {
    on('click', activateSidebarDetail, sidebarToggleButton)
  }
  if (closeButton) {
    on('click', deactivateSidebarDetail, closeButton)
  }

  on('resize', debounce(deactivateSidebarDetail), window)

  // common func checked all child items checkbox
  const checkedAllItems = (checkboxes) => {
    if (checkboxes.length > 0) {
      map(checkboxEl => {
        on('click', (e) => e.stopPropagation(), checkboxEl)
        on('change', (e) => {
          const target = e.target
          const parent = target.closest('.js-item')
          const parentList = target.closest('.js-accordion-sidebar-item')
          const checkboxes = selectAll('input[type="checkbox"]', parent)
          if (target.checked) {
            map(item => {
              item.checked = true
              if (hasClass('unchecked', item)) {
                removeClass('unchecked', item)
              }
            }, checkboxes)
          } else {
            map(item => { item.checked = false }, checkboxes)
          }
          activeFilterButtons()
          countItemsChecked(parent, parentList)
        }, checkboxEl)
      }, checkboxes)
    }
  }

  const checkedDefaultAllItems = (checkboxes) => {
    if (checkboxes.length > 0) {
      map(checkboxEl => {
        const target = checkboxEl
        const parent = target.closest('.js-item')
        const parentList = target.closest('.js-accordion-sidebar-item')

        // default load
        if (parent) {
          const itemHeadingEl = select('.js-toggle', parent)
          const parentCheckbox = select('input[type="checkbox"]', itemHeadingEl)
          const childCheckboxes = selectAll('.js-field__checkbox > input[type="checkbox"]', parent)
          const childCheckBoxesIsChecked = selectAll('.js-field__checkbox > input[type="checkbox"]:checked', parent)
          if (childCheckboxes.length === childCheckBoxesIsChecked.length) {
            parentCheckbox.checked = true
          } else {
            parentCheckbox.checked = false
          }
          if (childCheckBoxesIsChecked.length > 0 && childCheckboxes.length !== childCheckBoxesIsChecked.length) {
            addClass('unchecked', parentCheckbox)
          } else {
            removeClass('unchecked', parentCheckbox)
          }
        }

        countItemsChecked(parent, parentList)
      }, checkboxes)
    }
  }

  const countItemsChecked = (parent, parentList) => {
    // count checked list in item
    if (parent) {
      const itemsEl = selectAll('.js-item input:not([data-value="all"]):checked', parent)
      const countEl = select('.js-count', parent)
      if (itemsEl.length > 0) {
        countEl.innerHTML = ' (' + itemsEl.length + ')'
      } else {
        countEl.innerHTML = ''
      }
    }
    // count checked list in item accordion
    if (parentList) {
      const parentItems = selectAll('.js-accordion-sidebar-item input:not([data-value="all"]):checked', parentList)
      const countParentListEl = select('.js-count', parentList)
      if (parentItems.length > 0) {
        countParentListEl.innerHTML = ' (' + parentItems.length + ')'
      } else {
        countParentListEl.innerHTML = ''
      }
    }
  }

  const activeFilterButtons = () => {
    const checkedCheckboxes = selectAll('.js-field__checkbox > input:checked', el)
    const checkedRadios = selectAll('.js-field__radio > input:checked', el)
    const filterButtons = selectAll('.js-field-filter-buttons', el)
    const filterClearMobileEl = select('.js-sidebar-button-filter-clear', el)
    const sidebarToggleCountEl = select('.js-sidebar-toggle-count', el)

    if (checkedCheckboxes.length > 0 || checkedRadios.length > 0) {
      const countAll = checkedCheckboxes.length + checkedRadios.length
      if (sidebarToggleCountEl) {
        sidebarToggleCountEl.innerHTML = ' (' + countAll + ')'
      }
      if (filterButtons.length > 0) {
        map(filterButton => {
          const buttonEl = select('button', filterButton)
          if (buttonEl) {
            buttonEl.disabled = false
          }
          addClass('active', filterButton)
        }, filterButtons)
      }
      if (filterClearMobileEl) {
        addClass('active', filterClearMobileEl)
      }
    } else {
      if (sidebarToggleCountEl) {
        sidebarToggleCountEl.innerHTML = ''
      }
      if (filterButtons.length > 0) {
        map(filterButton => {
          const buttonEl = select('button', filterButton)
          if (buttonEl) {
            buttonEl.disabled = true
          }
          removeClass('active', filterButton)
        }, filterButtons)
      }
      if (filterClearMobileEl) {
        removeClass('active', filterClearMobileEl)
      }
    }
  }

  const handleChangeInput = (item) => {
    on('change', (e) => {
      const target = e.target
      const parent = target.closest('.js-item')
      const parentList = target.closest('.js-accordion-sidebar-item')
      activeFilterButtons()
      countItemsChecked(parent, parentList)
    }, item);
  }

  // common func unchecked checkbox all
  const uncheckedParent = (checkboxes) => {
    if (checkboxes.length > 0) {
      map(checkboxEl => {
        on('click', (e) => e.stopPropagation(), checkboxEl)
        on('change', (e) => {
          const target = e.target
          const parent = target.closest('.js-item')
          const parentList = target.closest('.js-accordion-sidebar-item')
          if (parent) {
            const itemHeadingEl = select('.js-toggle', parent)
            const parentCheckbox = select('input[type="checkbox"]', itemHeadingEl)
            const childCheckboxes = selectAll('.js-field__checkbox > input[type="checkbox"]', parent)
            const childCheckBoxesIsChecked = selectAll('.js-field__checkbox > input[type="checkbox"]:checked', parent)
            if (childCheckboxes.length === childCheckBoxesIsChecked.length) {
              parentCheckbox.checked = true
            } else {
              parentCheckbox.checked = false
            }
            if (childCheckBoxesIsChecked.length > 0 && childCheckboxes.length !== childCheckBoxesIsChecked.length) {
              addClass('unchecked', parentCheckbox)
            } else {
              removeClass('unchecked', parentCheckbox)
            }
            countItemsChecked(parent, parentList)
          }
        }, checkboxEl)
      }, checkboxes)
    }
  }

  // concept item checkbox all child
  const conceptsCheckboxes = selectAll('.js-filters-concepts-selected-all', el)
  checkedAllItems(conceptsCheckboxes)

  // standard item checkbox all child
  const standardsCheckboxes = selectAll('.js-filters-standards-selected-all', el)
  checkedAllItems(standardsCheckboxes)

  // un checked if exist parent checkbox
  const filterCheckboxes = selectAll('.js-item .js-field__checkbox input', el);
  uncheckedParent(filterCheckboxes)

  const checkboxes = selectAll('.js-field__checkbox > input[type="checkbox"]', el)
  if (checkboxes.length > 0) {
    map(checkbox => handleChangeInput(checkbox), checkboxes)
  }

  const radios = selectAll('.js-field__radio > input[type="radio"]', el)
  if (radios.length > 0) {
    map(radio => handleChangeInput(radio), radios)
  }

  const handleClearCheckedInput = (clearButtonEl) => {
    if (clearButtonEl) {
      const checkboxes = selectAll('input[type="checkbox"]', el)
      const radios = selectAll('input[type="radio"]', el)
      on('click', (e) => {
        let params = new URL(document.location.toString()).searchParams
        if (params.size == 0) {
          e.preventDefault()
          if (checkboxes.length > 0) {
            map(checkbox => {
              checkbox.checked = false
            }, checkboxes)
          }
          if (radios.length > 0) {
            map(radio => {
              radio.checked = false
            }, radios)
          }
          // clear count
          const countEls = selectAll('.js-count', el)
          if (countEls.length > 0) {
            map(countEl => {
              countEl.innerHTML = ''
            }, countEls)
          }
          activeFilterButtons()
        }
      }, clearButtonEl)
    }
  }

  const clearButtonEls = selectAll('.js-field-filter-clear', el)
  if (clearButtonEls.length > 0) {
    map(clearButtonEl => handleClearCheckedInput(clearButtonEl), clearButtonEls)
  }
  const clearButtonMobileEl = select('.js-sidebar-button-filter-clear', el)
  if (clearButtonMobileEl) {
    handleClearCheckedInput(clearButtonMobileEl)
  }

  // init load
  const initLoad = () => {
    activeFilterButtons()
    if (checkboxes.length > 0) {
      checkedDefaultAllItems(checkboxes)
    }
    if (radios.length > 0) {
      checkedDefaultAllItems(radios)
    }
  }
  initLoad()
}
